import type { AllSensorRuleFile } from '@/pages/Administration/AdministrationRules';
import {
  actionFormatter,
  fileNameFormatter,
  fileTypeFormatter,
  lastUpdatedFormatter,
  levelFormatter,
  standardFormatter
} from '@/pages/Administration/AdministrationRules';

export const COLUMNS = [
  {
    id: 'file_name',
    label: 'File Name',
    cell: (row: AllSensorRuleFile, handleClick: () => void) =>
      fileNameFormatter(row.file_name, handleClick),
    width: 300
  },
  {
    id: 'file_type',
    label: 'File Type',
    cell: (row: AllSensorRuleFile, handleClick: () => void) =>
      fileTypeFormatter(row.file_type, handleClick),
    width: 150
  },
  {
    id: 'level',
    label: 'Level',
    cell: (row: AllSensorRuleFile, handleClick: () => void) =>
      levelFormatter(row.level as 'global' | 'organization', handleClick),
    width: 100
  },
  {
    id: 'updated_at',
    label: 'Last Updated',
    cell: (row: AllSensorRuleFile, handleClick: () => void) =>
      row.updated_at && lastUpdatedFormatter(row.updated_at, handleClick),
    width: 150
  },
  {
    id: 'organization',
    label: 'Organization',
    width: 200,
    cell: (row: AllSensorRuleFile, handleClick: () => void) =>
      standardFormatter(row.organization as string, handleClick),
    hidden: (selectedOrganizationId: number) => selectedOrganizationId === 0
  },
  {
    id: 'action',
    cell: (row: AllSensorRuleFile) => actionFormatter(row),
    width: 50
  }
];

export default COLUMNS;
